import {
  Page,
  Text,
  View,
  Document,
  StyleSheet
} from "@react-pdf/renderer";

const styles = StyleSheet.create({
  page: { padding: 20, fontSize: 8 },
  header: { fontSize: 16, textAlign: "center", marginBottom: 10 },
  row: { flexDirection: "row" },
  cell: {
    border: "1px solid black",
    padding: 2,
    textAlign: "center",
    flex: 1
  },
  tableHeader: {
    backgroundColor: "#eee",
    fontWeight: "bold"
  }
});

export default function ProductionFilmPDF({ data }) {
  return (
    <Document>
      <Page size="A4" style={styles.page}>

        {/* HEADER */}
        <Text style={styles.header}>PRODUCTION FILM</Text>

        <View style={styles.row}>
          <Text>Date: {data.date}</Text>
          <Text>Shift: {data.shift}</Text>
          <Text>Operator: {data.operator}</Text>
        </View>

        {/* MAIN TABLE */}
        <View style={{ marginTop: 10 }}>
          <View style={[styles.row, styles.tableHeader]}>
            <Text style={styles.cell}>Time</Text>
            <Text style={styles.cell}>Production</Text>
            <Text style={styles.cell}>Changeover</Text>
            <Text style={styles.cell}>Breakdown</Text>
            <Text style={styles.cell}>Material</Text>
            <Text style={styles.cell}>People</Text>
            <Text style={styles.cell}>Planned</Text>
          </View>

          {[...Array(16)].map((_, i) => (
            <View key={i} style={styles.row}>
              <Text style={styles.cell}>{i + 0.5} Hr</Text>
              <Text style={styles.cell}></Text>
              <Text style={styles.cell}></Text>
              <Text style={styles.cell}></Text>
              <Text style={styles.cell}></Text>
              <Text style={styles.cell}></Text>
              <Text style={styles.cell}></Text>
            </View>
          ))}
        </View>

        {/* DECLARED HOURS */}
        <View style={{ marginTop: 10 }}>
          <Text>Declared Hours</Text>
          <View style={styles.row}>
            {Object.entries(data.stop_reasons_hours).map(([k, v]) => (
              <Text key={k} style={styles.cell}>{k}: {v}h</Text>
            ))}
          </View>
        </View>

        {/* BOTTOM TABLE */}
        <View style={{ marginTop: 10 }}>
          <View style={styles.row}>
            <Text style={styles.cell}>Reference</Text>
            <Text style={styles.cell}>Good Parts</Text>
            <Text style={styles.cell}>Cycle Time</Text>
            <Text style={styles.cell}>Theoretical Hrs</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.cell}>{data.part_number}</Text>
            <Text style={styles.cell}>{data.good_parts}</Text>
            <Text style={styles.cell}>{data.ideal_cycle_time}</Text>
            <Text style={styles.cell}>
              {(data.good_parts * data.ideal_cycle_time / 3600).toFixed(2)}
            </Text>
          </View>
        </View>

        {/* OEE */}
        <View style={{ marginTop: 10 }}>
          <Text>OEE</Text>
          <Text>{data.oee}%</Text>
        </View>

      </Page>
    </Document>
  );
}
